import { Component, Inject, Optional, ViewChild } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { SelectItem } from 'primeng/api';
import { DriverBaseComponent } from '../../../driver/driver-base-component';
import { IMedicalExamCertificateDecisionType } from '../../../driver/models/enums/medical-exam-certificate-decision-type.enum';
import { IncidentConfirmationService } from '../../../driver/services/incident-confirmation/incident-confirmation.service';
import { IJurisdiction } from '../../../foundation/models/enums/jurisdiction.enum';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { MedicalReviewReportContext } from '../../models/medical-review-report-context.model';
import { MedicalExamCertificateComponent } from './medical-exam-certificate.component';

@Component({
    templateUrl: './medical-exam-certificate-modal.html'
})
export class MedicalExamCertificateModalComponent extends DriverBaseComponent {
    public restrictionTypes: SelectItem[];
    public jurisdictions: IJurisdiction[];
    public mecDecisionTypes: IMedicalExamCertificateDecisionType[];
    public mecWaiverTypes: SelectItem[];
    public mecExemptionTypes: SelectItem[];
    public isFormValid = false;
    public waiverIds: number[];
    public exemptionIds: number[];
    public waivers: UntypedFormArray;
    public exemptions: UntypedFormArray;
    public saving = false;
    public showEligibilityMessage = false;
    public eligibilityStatus: boolean;
    @ViewChild(MedicalExamCertificateComponent, { static: true })
    public medicalExamCertificate: MedicalExamCertificateComponent;

    constructor(
        public dialogRef: MatDialogRef<MedicalExamCertificateModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: MedicalReviewReportContext,
        private incidentConfirmationService: IncidentConfirmationService,
        private modalService: MvdModalService

    ) {
        super();
    }

    public ngOnInit() {
    }

    public save = (): void => {

        let isValid = this.medicalExamCertificate.validateMedicalExamCertificateRestrictions();
        if (!isValid) {
            this.modalService.confirm().title('new waiver/exemption').body('Customer needs new waiver, exemption or SPE. Continue saving?').okBtn('Yes').cancelBtn('No').open().afterClosed().subscribe(result => {
                if (!!result) {
                    this.saveMedicalExamCertificate();
                }
            });
        } else {
            this.saveMedicalExamCertificate();
        }
    };

    private saveMedicalExamCertificate() {
        this.medicalExamCertificate.save(this.data)
            .subscribe({
                next: result => {
                    if (!!result) {
                        this.dialogRef.close(result);
                    }
                },
                error: e => this.handleErrors(e.error)
            });
    }

    private handleErrors(e: any) {
        if (e && e.validationResults) {

            let blockingValidationResults = e.validationResults.filter(i => 'REDIRECT_ADMINISTRATIVE_ACTION' != i.state.errorCode);

            if (!!blockingValidationResults && blockingValidationResults.length > 0) {
                this.handleValidationResult(e);
                return;
            }

            this.incidentConfirmationService.confirmIncidentRedirect(null, e, this.dialogRef);
            // the incident redirect will only close if confirm is clicked.
            // Want to close MEC modal regardless, otherwise it looks like we didn't save anything when we actually did
            this.dialogRef.close();
        }
    }

    public close = (): void => {
        this.dialogRef.close();
    };

    public formValidationStatus = (event: boolean): void => {
        this.isFormValid = event;
    };

    public isSaving = (event: boolean): void => {
        this.saving = event;
    };

    public showEligibilityStatus = (event: boolean): void => {
        this.eligibilityStatus = event;
        this.showEligibilityMessage = true;
    };
}
